// extracted by mini-css-extract-plugin
export default {"continer":"Login_continer__UAQin","continer2":"Login_continer2__DC1QM","left":"Login_left__VFrPf","right":"Login_right__2brHU","form":"Login_form__cgXw-"};